<!-- @Version: 1.0.3 -->
@if (done$$() == true) {
   <div data-testid="textareaContainer" class="realy-textarea" [formGroup]="fgTextarea" class="row" data-width="100%">
      <mat-form-field data-width="100%" [hideRequiredMarker]="hideRequireMaker" >
         @if (fieldItem.attribute_1 && fieldItem.attribute_1 != '') {
         <mat-label data-testid="label" [innerHTML]="fieldItem.attribute_1!"></mat-label>
         }
         <textarea data-testid="input" matInput [formControlName]="FC_TEXTAREA.TEXTAREA" [placeholder]="fieldItem.placeholder ?? ''"></textarea>
         @if (fgTextarea.get(FC_TEXTAREA.TEXTAREA)?.hasError(VALIDATORS.pattern)) {
         <mat-error data-testid="errorPattern" [innerHTML]="errorCodes.errorCodePattern"></mat-error>
         }
         @else if (fgTextarea.get(FC_TEXTAREA.TEXTAREA)?.hasError(VALIDATORS.maxlength) && fgTextarea.get(FC_TEXTAREA.TEXTAREA)?.touched) {
         <mat-error data-testid="errorMaxSize" [innerHTML]="errorCodes.errorCodeMaxSize"></mat-error>
         }
         @else if (fgTextarea.get(FC_TEXTAREA.TEXTAREA)?.hasError(VALIDATORS.required) && fgTextarea.get(FC_TEXTAREA.TEXTAREA)?.touched) {
         <mat-error data-testid="errorRequired" [innerHTML]="errorCodes.errorCodeRequired"></mat-error>
         }
      </mat-form-field>
   </div>
}